<template>
  <div class="task-documents">
    <div class="task-documents__actions text-right" v-if="!isAddActive">
      <button class="btn btn-sm btn-primary my-3" @click="addDocument">добавить документ</button>
    </div>
    <div class="task-documents__add-document" v-if="isAddActive">
       <div class="status-filters d-flex align-items-baseline ml-4 mt-3">
          <div
            class="status-fiter"
            @click="toggeleAddFromLayouts"
            :class="{'filter-active' : isAddFromLayouts}"
          >
            <p class="h3">Из шаблонов</p>
          </div>
          <div
            v-if="clientDocuments.length > 0"
            class="status-fiter"
            @click="toggeleAddFromDocumens"
            :class="{'filter-active' : isAddFromDocumens}"
          >
            <p class="h3">Из документов</p>
          </div>
        </div>
        <div class="task-documents__add task-documents__add--layout" v-if="isAddFromLayouts">
          <div class="task-documents__add-from-layout d-flex p-3 align-items-center">
            <select class="form-control custom-select ml-2" v-model="newDocument.layoutId" id="layoutsSelect">
              <option value="null" disabled selected hidden>Выберите шаблон</option>
              <option v-for="layout in documentLayouts" :key="layout.id" :value="layout.id" :selected="layout.id === newDocument.layoutId">{{ layout.name }}</option>
            </select>
            <label class="mx-2" for="documentDate">от</label>
            <datepicker
              id="documentDate"
              class=""
              v-model="newDocument.date"
              :start-date ="new Date(1900,0,0)"
            ></datepicker>
            <label class="mx-2" for="documentDate">номером</label>
            <input
                type="text"
                class="form-control"
                id="number"
                v-model="newDocument.number"
              />
              <div class="custom-control custom-checkbox ml-3">
                <input type="checkbox" id="isReusable" class="custom-control-input" v-model="newDocument.isReusable" />
                <label class="custom-control-label" for="isReusable">общий</label>
              </div>
            <button @click="cancelAddDocument" class="btn btn-sm btn-outline-primary ml-4">Отмена</button>
            <button @click="createDocumentFromLayout" :disabled="!newDocument.layoutId" class="btn btn-sm btn-primary ml-2">Создать</button>
          </div>
        </div >
        <div class="task-documents__add task-documents__add--document" v-if="isAddFromDocumens">
          <div class="task-documents__add-from-documents  d-flex p-3 align-items-center">
            <select lect class="form-control custom-select ml-2" v-model="newDocument.documentId" id="documentSelect">
              <option value="null" disabled selected hidden>Выберите документ</option>
              <option v-for="document in clientDocuments" :key="document.id" :value="document.id" :selected="document.id === newDocument.documentId">{{ document.name }}</option>
            </select>
            <button @click="cancelAddDocument" class="btn btn-sm btn-outline-primary ml-4">Отмена</button>
            <button @click="createDocumentFromDocuments" class="btn btn-sm btn-primary ml-2">Создать</button>
          </div>
        </div>
    </div>
    <div class="task-documents__documents">
      <ul class="list-unstyled">
        <li v-for="parentDocument in parentDocuments" :key="parentDocument.id" class="mt-3">
          <div class="d-flex justify-content-between">
            <div>
              <span>{{parentDocument.updateTime}}</span>
              <a :href="`/api/documents/${parentDocument.id}/pdf`" target="_blank" class="ml-2">{{parentDocument.name}}</a><span class="ml-1">от {{parentDocument.datetime}} номером {{parentDocument.number}}</span>
            </div>
            <div v-if="!isAddChildDocumentActive(parentDocument.id)">
              <button @click="addChildDocument(parentDocument.id)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-plus"></i></button>
              <button @click="showSendDocumentModal(parentDocument)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-send-message"></i></button>
              <button @click="editDocument(parentDocument.id)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-pencil"></i></button>
              <button @click="deleteDocument(parentDocument.id)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-delete"></i></button>
            </div>
          </div>
          <div class="task-documents__add-child" v-if="isAddChildDocumentActive(parentDocument.id)">
            <div v-for="childDocumentForAdd in [getChildDocumentForAdd(parentDocument.id)]" :key="childDocumentForAdd.parentId" class="d-flex p-3 align-items-center">
              <select class="form-control custom-select ml-2" v-model="childDocumentForAdd.layoutId" :id="`layoutsSelect-${childDocumentForAdd.parentId}`">
                <option value="null" disabled selected hidden>Выберите шаблон</option>
                <option v-for="layout in documentLayouts" :key="layout.id" :value="layout.id" :selected="layout.id === childDocumentForAdd.layoutId">{{ layout.name }}</option>
              </select>
              <label class="mx-2" for="documentDate">от</label>
              <datepicker
                id="documentDate"
                class=""
                v-model="childDocumentForAdd.date"
                :start-date ="new Date(1900,0,0)"
              ></datepicker>
              <label class="mx-2" for="documentDate">номером</label>
              <input
                  type="text"
                  class="form-control"
                  id="number"
                  v-model="childDocumentForAdd.number"
                />
              <button @click="cancelAddChildDocument(childDocumentForAdd.parentId)" class="btn btn-sm btn-outline-primary ml-4">Отмена</button>
              <button @click="createChildDocument(childDocumentForAdd.parentId)" :disabled="!childDocumentForAdd.layoutId" class="btn btn-sm btn-primary ml-2">Создать</button>
            </div>
          </div>
          <ul class="list-unstyled px-4">
            <li v-for="childDocument in getChildDocuments(parentDocument.id)" :key="childDocument.id" class="d-flex justify-content-between mt-1">
              <div>
                <span>{{childDocument.updateTime}}</span>
                <a :href="`/api/documents/${childDocument.id}/pdf`" target="_blank" class="ml-2">{{childDocument.name}}</a> <span class="ml-1">от {{childDocument.datetime}} номером {{childDocument.number}}</span>
              </div>
              <div>
                <button @click="showSendDocumentModal(childDocument)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-send-message"></i></button>
                <button @click="editDocument(childDocument.id)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-pencil"></i></button>
                <button @click="deleteDocument(childDocument.id)" class="btn btn-sm btn-primary ml-2 px-3"><i class="ico ico-delete"></i></button>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../../api'
import datepicker from '../../components/datepicker.vue'
import SendDocumentModal from './SendDocumentModal.vue'

export default {
  name: 'TaskDocuments',
  components: {
    datepicker
  },
  props: {
    taskId: {
      type: String,
      default: null
    },
    taskNumber: {
      type: String,
      default: null
    },
    client: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isAddActive: false,
      isAddFromLayouts: false,
      isAddFromDocumens: false,
      documents: [],
      childDocumentsToAdd: [],
      documentLayouts: [],
      clientDocuments: [],
      newDocument: {}
    }
  },
  created () {
    this.setDocumentLayouts()
    this.setClientDocuments()
    this.setDocuments()
  },
  computed: {
    parentDocuments () {
      return this.documents.filter(x => !x.parent)
    }
  },
  methods: {
    toggeleAddFromLayouts () {
      this.isAddFromLayouts = true
      this.isAddFromDocumens = false
    },
    toggeleAddFromDocumens () {
      this.isAddFromLayouts = false
      this.isAddFromDocumens = true
    },
    getDefaultDocumentData (parentId) {
      return {
        layoutId: null,
        documentId: null,
        date: new Date(),
        number: this.taskNumber,
        isReusable: false,
        parentId: parentId
      }
    },
    addDocument () {
      this.isAddActive = true
      this.isAddFromLayouts = true
      this.isAddFromDocumens = false
      this.newDocument = this.getDefaultDocumentData()
    },
    addChildDocument (parentId) {
      const newChildDocument = this.getDefaultDocumentData(parentId)
      this.childDocumentsToAdd.push(newChildDocument)
    },
    cancelAddDocument () {
      this.isAddActive = false
      this.isAddFromLayouts = false
      this.isAddFromDocumens = false
    },
    cancelAddChildDocument (parentId) {
      this.childDocumentsToAdd = this.childDocumentsToAdd.filter(x => x.parentId !== parentId)
    },
    getChildDocuments (parentId) {
      return this.documents.filter(x => x.parent === parentId)
    },
    getChildDocumentForAdd (parentId) {
      return this.childDocumentsToAdd.find(x => x.parentId === parentId) || {}
    },
    isAddChildDocumentActive (parentId) {
      return this.childDocumentsToAdd.some(x => x.parentId === parentId)
    },
    editDocument (id) {
      this.$router.push(`/document-editor/${id}`)
    },
    deleteDocument (id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: async () => {
              try {
                await api.delete.document(id)
                this.documents = this.documents.filter(x => x.id !== id)
              } catch {
                // ignore
              }
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    async showSendDocumentModal (document) {
      const defaultEmail = this.client.email || (this.client.legal_entity ? this.client.legal_entity.email : '')
      let companyEmails = [{ email: defaultEmail, isDefault: true }]

      if (this.client.legal_entity) {
        try {
          const resp = await api.get.companyClients(this.client.legal_entity.id)
          const companyClientEmails = resp.data.data.clients
            .filter(x => x.email && x.email !== defaultEmail)
            .map(x => ({ email: x.email, isDefault: false }))
          companyEmails = companyEmails.concat(companyClientEmails)
        } catch {}

        if (defaultEmail !== this.client.legal_entity.email) {
          companyEmails.push({ email: this.client.legal_entity.email, isDefault: false })
        }
      }

      const modalProps = {
        companyEmails,
        document
      }
      this.$modal.show(SendDocumentModal, {
        ...modalProps
      }, {
        height: 'auto'
      })
    },
    async createDocumentFromLayout () {
      const model = {
        lid: this.newDocument.layoutId,
        tid: this.taskId,
        reusable: this.newDocument.isReusable,
        number: this.newDocument.number,
        datetime: this.newDocument.date
      }

      try {
        await api.post.addDocumentFromTask(model)
      } finally {
        this.setDocuments()
        this.cancelAddDocument()
      }
    },
    async createDocumentFromDocuments () {
      const model = {
        did: this.newDocument.documentId,
        tid: this.taskId
      }

      try {
        await api.post.addDocumentFromTask(model)
      } finally {
        this.setDocuments()
        this.cancelAddDocument()
      }
    },
    async createChildDocument (parentId) {
      const childDocumentForAdd = this.childDocumentsToAdd.find(x => x.parentId === parentId)

      const model = {
        lid: childDocumentForAdd.layoutId,
        number: childDocumentForAdd.number,
        datetime: childDocumentForAdd.date,
        did: childDocumentForAdd.parentId
      }

      try {
        await api.post.addDocumentFromTask(model)
      } finally {
        this.setDocuments()
        this.cancelAddChildDocument(parentId)
      }
    },
    async setClientDocuments () {
      try {
        const { data } = await api.get.clientDocuments(this.taskId)
        this.clientDocuments = data.data.documents
      } catch {
        this.clientDocuments = []
      }
    },
    async setDocumentLayouts () {
      try {
        const { data } = await api.get.documentLayouts()
        this.documentLayouts = data.data.layouts
      } catch {
        this.documentLayouts = []
      }
    },
    async setDocuments () {
      try {
        const { data } = await api.get.taskDocuments(this.taskId)
        this.documents = data.data.documents.map(x => ({ ...x, updateTime: moment(x.mtime).format('DD.MM.YYYY HH:mm') }))
      } catch {
        this.documents = []
      }
    }
  }
}
</script>

<style lang="scss">
.task-documents {
  &__add-from-layout,
  &__add-from-documents,
  &__add-child {
    .form-control {
      max-width: 200px;
    }
  }
}
</style>
